import type { IconData } from '@stacksjs/iconify-core'

export const deleteBookmarkFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 2.5c-6.488 0-10.516.577-12.909 1.14c-2.505.591-3.918 2.759-4.088 5.061C6.779 11.715 6.5 17.236 6.5 26c0 6.958.102 11.522.232 14.516c.085 1.937.914 3.613 2.535 4.365c1.584.734 3.412.343 4.993-.695l7.271-4.772a4.5 4.5 0 0 1 4.938 0l7.27 4.772c1.582 1.038 3.41 1.429 4.994.695c1.62-.752 2.45-2.428 2.535-4.365c.13-2.994.232-7.558.232-14.516c0-8.764-.28-14.285-.503-17.299c-.17-2.302-1.583-4.47-4.088-5.06C34.516 3.077 30.488 2.5 24 2.5\"/><path fill=\"#2859c5\" d=\"M28.242 28.07a2 2 0 1 0 2.828-2.828L26.828 21l4.242-4.242a2 2 0 1 0-2.828-2.829L24 18.172l-4.242-4.243a2 2 0 0 0-2.829 2.828L21.171 21l-4.243 4.243a2 2 0 1 0 2.829 2.828l4.242-4.242l4.243 4.242Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default deleteBookmarkFlat
